import { render, staticRenderFns } from "./CascaderCom.vue?vue&type=template&id=f4a09670&scoped=true&"
import script from "./CascaderCom.vue?vue&type=script&lang=js&"
export * from "./CascaderCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a09670",
  null
  
)

export default component.exports